import { DashboardRoutes } from "@/router";
import { useNavigate } from "react-router-dom";
import { isMobilePersonalRegisterURL } from "@/utils/isRegisterURL";

export function useHandleNavigationURL() {
  const isRegisterURL = isMobilePersonalRegisterURL();
  const { settings, register } = DashboardRoutes;
  const navigate = useNavigate();

  const handleNavigationURL = () => {
    if (isRegisterURL) return navigate(register.personal.url);
    return navigate(settings.personal.root.url);
  };

  return { handleNavigationURL };
}
